export default "__VITE_ASSET__DkWOKkL7__"